export default {"src":"/_next/static/media/plane.080a3ea9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};